import { render } from "./TabMedia.vue?vue&type=template&id=f3169db6"
import script from "./TabMedia.vue?vue&type=script&lang=js"
export * from "./TabMedia.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__